import { useSelector } from 'react-redux'
import { RootState } from '@/stores'
import Slab from '../common/Slab'
import SideOnChannel from './SideOnChannel'
import HorizontalMeasurement from '../lines/HorizontalMeasurement'
import VerticalMeasurement from '../lines/VerticalMeasurement'

const slabProperties = {
  slabWidth: 60,
  slabHeight: 80,
}

const channelProperties = {
  channelWidth: 15,
  channelHeight: 20,
  anchorLength: 30,
  anchorThickness: 7,
  anchorHeadThickness: 8,
  anchorHeadDiameter: 12,
}

const measurementProperties = {
  measurementYPadding: 20,
  measurementXPadding: 20,
}

const derivedProperties = {
  channelYOffset: (slabProperties.slabHeight / 2) - (channelProperties.channelHeight / 2),
  measurementYOffset: slabProperties.slabHeight + measurementProperties.measurementYPadding,
  hefLength: channelProperties.channelWidth + channelProperties.anchorLength,
  fLength: channelProperties.anchorHeadThickness,
}

type PropTypes = {
  xOffset?: number,
  yOffset?: number,
}

const SideOnDiagram = ({ xOffset = 0, yOffset = 0 }: PropTypes) => {
  const channel = useSelector((state: RootState) => state.activeDesign.design?.components?.find(c => c.cast_in_anchor_channel))

  return (
    <g>
      <Slab
        height={slabProperties.slabHeight}
        width={slabProperties.slabWidth}
        xOffset={xOffset}
        yOffset={yOffset}
      />
      {
        channel
        && (
          <SideOnChannel
            height={channelProperties.channelHeight}
            width={channelProperties.channelWidth}
            xOffset={xOffset}
            yOffset={yOffset + derivedProperties.channelYOffset}
            anchorLength={channelProperties.anchorLength}
            anchorThickness={channelProperties.anchorThickness}
            anchorHeadThickness={channelProperties.anchorHeadThickness}
            anchorHeadDiameter={channelProperties.anchorHeadDiameter}
          />
        )
      }
      {
        channel
        && (
          <g>
            <HorizontalMeasurement
              startPoint={xOffset}
              endPoint={xOffset + slabProperties.slabWidth}
              yOffset={yOffset + derivedProperties.measurementYOffset}
              label="h"
            />
            <VerticalMeasurement
              startPoint={yOffset + (slabProperties.slabHeight / 2)}
              endPoint={yOffset}
              xOffset={xOffset - measurementProperties.measurementXPadding}
              label="c1,1"
            />
            <VerticalMeasurement
              startPoint={yOffset + (slabProperties.slabHeight / 2)}
              endPoint={yOffset + slabProperties.slabHeight}
              xOffset={xOffset - measurementProperties.measurementXPadding}
              label="c1,2"
            />
          </g>
        )
      }
    </g>
  )
}

export default SideOnDiagram
